export default "__VITE_ASSET__hqMfPVe9__"